import * as React from "react";
import { forwardRef } from "react";
const SvgQa = (props, ref) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ref, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M14.5 15.2H14.8292L15.094 15.3956L20 19.0184V4H4V15.2H14.5Z", stroke: "currentcolor", fill: "none", strokeWidth: 2 }));
const ForwardRef = forwardRef(SvgQa);
export default ForwardRef;
